export default __webpack_public_path__ + "0bdf08a40bf4392fa9fbf409f8f48ad8.png";